import './Welcome.css';
import ApplyNow from '../ApplyNow/ApplyNow';
import { useCreatorCashContext } from '../../../context/CreatorCashProvider';
import FadeInSection from '../../FadeInComponent/FadeInComponent';

export default function Welcome({ scrollToRef }) {

    const { state } = useCreatorCashContext();
    const welcomeContent = state?.welcomeSection;

    return (
        <div className='creator-cash-welcome-container'>
            <FadeInSection>
                <div className='welcome-wrapper'>
                    <div className="welcome-text">
                        <div className="welcome-title-wrapper">
                            <div className="welcome-title">
                                {
                                    welcomeContent?.title?.map((title, index) =>
                                        <div key={index} className={`${title?.isUpperCase ? 'uppercase' : 'capitalize'} ${title?.isInGreen ? 'text-green' : 'text-white'}`}>
                                            {title?.value}
                                        </div>
                                    )
                                }
                            </div>
                            <div className="let-us-help-underline"></div>
                        </div>
                        <div className="welcome-sub-title">
                            {welcomeContent?.subTitle?.map((title, index) => <div key={index}>{title}</div>)}
                        </div>
                    </div>
                    {welcomeContent?.showApplyNowButton && <ApplyNow className={'welcome-apply-now-button'} label={'Check Eligibility'} onClick={scrollToRef} />}
                </div>
            </FadeInSection>
        </div>
    )
}